import { useEffect } from 'react';
import { useUserSettingsSelector } from '../../redux/selectorHooks';

const useDarkModeEffect = () => {
  const colorSchemaSetting = useUserSettingsSelector('colorSchemaSetting');

  useEffect(() => {
    const isDarkModeEnabled = colorSchemaSetting === 'DARK';
    if (isDarkModeEnabled) {
      document.body.classList.add('dark');
    } else if (document.body.classList.contains('dark')) {
      document.body.classList.remove('dark');
    }
  }, [colorSchemaSetting]);
};

export default useDarkModeEffect;
